import { CALENDAR_POSITION, DATE_PICKER_HEIGHT } from '../constants';

export const getCalendarPosition = (refContainer) => {
  const boundingRectPosition = refContainer?.current.getBoundingClientRect() || { top: 0, bottom: 0 };
  const spaceBelowDatePicker = window.innerHeight - boundingRectPosition.bottom - DATE_PICKER_HEIGHT;
  const spaceAboveDatePicker = boundingRectPosition.top - DATE_PICKER_HEIGHT;

  return spaceBelowDatePicker < 0 && spaceAboveDatePicker > 0 ? CALENDAR_POSITION.up : CALENDAR_POSITION.down;
};
